<template>
  <div class="mainContainer" :style="loginImage">
    <TopHeader :pageTitle="pageHead" />
    <!----------------Main Page------------------------------------------>
    <div class="pageContainer shadow-lg rounded" fluid="sm">
      <div class="page-content">
        <SecondaryHeader @openSidepane="onClickChild" />
        <b-card no-body class="tab-wrapper" :class="bodyPanel">
          <b-tabs card>
            <UserRegistration />
            <ApprovedUsers />
            <pending-user></pending-user>
            <rejected-users></rejected-users>
          </b-tabs>
        </b-card>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import TopHeader from "@/components/BaseFiles/TopHeader.vue";
import SecondaryHeader from "@/components/BaseFiles/SecondHeader.vue";
import UserRegistration from "./UserRegistration.vue";
import ApprovedUsers from "./ApprovedUsers.vue";
import PendingUser from "./PendingUser.vue";
import RejectedUsers from "./RejectedUsers.vue";
import bgImage from "@/assets/img/dbTiles/BG.png";
export default {
  name: "UserManagement",
  components: {
    TopHeader,
    SecondaryHeader,
    UserRegistration,
    ApprovedUsers,
    PendingUser,
    RejectedUsers,
  },
  computed: {
    ...mapGetters(["approvedUsers", "pendingUsers", "rejectedUsers"]),
  },
  data() {
    return {
      pageHead: "Administrative Settings",
      loginImage: {
        backgroundImage: "url(" + bgImage + ")",
      },
      bodyPanel:'bodyPanelOpen'
    };
  },
  created() {
    // this.getMasterChartsInfo();
    this.getAllUserList();
    this.countryCode();
  },
  methods: {
    ...mapActions(["getMasterChartsInfo", "getAllUserList", "countryCode"]),
    onClickChild (value) {
        if(value){
            this.bodyPanel = 'bodyPanel';
        }else{
            this.bodyPanel = 'bodyPanelOpen';
        }
    },
  },
};
</script>

<style lang="scss">
.containerWrapper {
  background: $color-white;
  position: relative;
  margin: 1rem;
  height: 84%;
  overflow-y: auto;
  overflow-x: hidden;
  left: 15vw;
  width: 83%;
}

.tabWrapper {
  position: relative;
  height: 76vh;
}

.userMgmtCard {
  .col-auto {
    // .ul {
    //     background: $color-dark-grey !important;
    //     border: none;
    // }

    .nav-pills .nav-link.active,
    .nav-pills .show > .nav-link {
      background-color: transparent !important;
    }

    height: 76vh;
  }

  .card-body {
    padding: 0 !important;
  }

  .card-header {
    padding: 1rem 0.4rem;
    background: $color-dark-grey !important;
    border: none;
  }
}

.userMgmtSubTabs {
  ul {
    background: $base-color !important;
  }

  a {
    color: $color-white;
  }

  .card-text {
    padding: 1em;
  }

  .actionIcon {
    color: #bbb9b9;
    cursor: pointer;
    margin-right: 5px;
    font-size: 1rem;
  }
}

.userTbl {
  .form-group {
    margin-bottom: 0 !important;
  }
}

label,
input {
  position: relative;
  display: inline-block;
  margin-right: 2%;
  font-weight: 600;
  font-size: 13px;
}

.form-control {
  display: inline-block !important;
  font-size: 0.75rem !important;
  font-weight: normal;
}

.disclaimerText {
  font-size: 3rem;
  font-weight: bold;
  color: #d2d2d2;
  position: relative;
  text-align: center;
  padding-top: 15%;
}
.tab-wrapper .tab-content{
  overflow: auto;
}
</style>
